import * as React from "react";
import { select, Selection } from "d3-selection";
import "d3-transition";
import { IResult } from "./IOPair";
import { isEqual } from "lodash";
interface IChartProps {
  data: IResult[];
  transitionDuration: number;
  xScale(x0: number): number;
  yScale(y0: number): number;
}

interface IChartState {
  xScale0: ((x0: number) => number) | null;
  yScale0: ((y0: number) => number) | null;
}

class Labels extends React.Component<IChartProps, IChartState> {
  public readonly state = {
    xScale0: null,
    yScale0: null
  };
  private gref: React.RefObject<SVGGElement>;
  constructor(props: any) {
    super(props);
    this.gref = React.createRef();
  }
  public renderData = (g: Selection<SVGGElement, {}, null, undefined>) => {
    const x = this.props.xScale;
    const y = this.props.yScale;
    // const x0 = this.state.xScale0 || x;
    // const y0 = this.state.yScale0 || y;
    const data = this.props.data;

    g.each((_: any, i: any, n: any) => {
      const c = select(n[i])
        .selectAll("text")
        .data(data, (d: IResult) => {
          return d.word;
        });
      c.enter()
        .append("text")
        .attr("x", (d: IResult) => x(d.x))
        .attr("y", (d: IResult) => y(d.y))
        .text(d => d.word)
        .style("opacity", 1);
      // c.enter()
      //   .append("text")
      //   .attr("x", (d: any) => x0(d.x))
      //   .attr("y", (d: any) => y0(d.y))
      //   .attr("dy", -10)
      //   .style("opacity", 1e-6);
      // transition(c as Selection<SVGGElement, {}, BaseType, undefined>)
      //   .attr("cx", (d: any) => x(d.x))
      //   .attr("cy", (d: any) => y(d.y))
      //   .attr("r", (d: any) => 3)
      //   .style("opacity", 1)
      //  .text((d) => d.id);
      c.exit().remove();
    });
  };
  public componentDidUpdate(prevProps: IChartProps, prevState: IChartState) {
    if (
      prevProps.xScale(1) !== this.props.xScale(1) ||
      prevProps.yScale(1) !== this.props.yScale(1) ||
      !isEqual(prevProps.data, this.props.data)
    ) {
      this.setState({ xScale0: prevProps.xScale, yScale0: prevProps.yScale });
      if (this.gref.current !== null) {
        select(this.gref.current).call(this.renderData);
      }
    }
  }
  public componentDidMount() {
    if (this.gref.current !== null) {
      select(this.gref.current).call(this.renderData);
    }
  }
  public render() {
    return <g ref={this.gref} />;
  }
}
export default Labels;



// WEBPACK FOOTER //
// ./src/Scatterplot-Labels.tsx